import React from 'react';
import DictionaryRow from './DictionaryRow';

const DictionariesTableRows = ({
  category,
  className,
  columns,
  items,
  onCheckBoxClick,
  selectable,
}) => (
  items.map((item) => (
    <DictionaryRow
      className={className}
      key={`dictionaries_table_row_${item.id}`}
      category={category}
      dictionary={item}
      onCheckBoxClick={onCheckBoxClick}
      columns={columns}
      selectable={selectable}
    />
  ))
);

export default DictionariesTableRows;
